import { callApi } from './api';

import { SupportPlanDraftRequest } from '@/types/supportPlan';

export const createSupportPlanDraft = async (requestBody: SupportPlanDraftRequest) => {
  const { status, result } = await callApi<boolean>(
    'support-plan-drafts',
    'POST',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
